import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Dropdowns.scss';

function DropdownHeaderText({ text }) {
    return (<span className={styles['dropdown-window-header-text']}>
        {text}
    </span>)
}

DropdownHeaderText.displayName = displayName('Dropdowns/DropdownHeaderText');

DropdownHeaderText.propTypes = {
    text: PropTypes.string.isRequired,
};

export default DropdownHeaderText;
